import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  borderRadius: '12px',
  border: '1px solid #E2E8F0',
  boxShadow: 'none',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-4px)',
    transition: 'transform 0.2s ease-in-out',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
  }
}));

const StyledCardMedia = styled(CardMedia)({
  height: 200,
  backgroundSize: 'contain',
  backgroundColor: '#F8FAFC',
  borderBottom: '1px solid #E2E8F0'
});

const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  color: '#1A365D',
  marginBottom: '0.5rem'
}));

const CompanyChip = styled(Chip)(({ theme }) => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(4px)',
  fontWeight: 500,
  color: '#1A365D'
}));

const AccreditationCard = ({ accreditation, company }) => {
  const { title, number, description, image, sector, type, accreditationType, link } = accreditation;
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  return (
    <StyledCard onClick={handleClick}>
      
      <CardContent>
      
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#1A365D',
            fontWeight: 500,
            mb: 1
          }}
        >
          {type} {accreditationType ? `${accreditationType.toUpperCase()} ` : ''}{number ? `N°:${number}` : ''}
        </Typography>
        
        <Box display="flex" gap={1}>
          <Chip 
            label={sector}
            sx={{
              borderColor: '#E2E8F0',
              color: '#475569',
              fontWeight: 500,
              height: 'auto',
              '& .MuiChip-label': {
                whiteSpace: 'normal',
                display: 'block',
                padding: '8px',
                lineHeight: 1.2
              }
            }}
            variant="outlined"
            size="small"
          />
          
        </Box>
        
      </CardContent>
    </StyledCard>
  );
};

export default AccreditationCard;
